module.exports = __webpack_public_path__ + "img/header-memoireRingsGold.bfb7acc.jpg";